<template>
  <div>
    <v-card
      flat
      class="mx-0 px-0 transparent"
      :class="enquiry.state === 'Active' || UserHasRole('Platform') ? 'is-link' : ''"
      @click.native="redirectToCustomer"
    >
      <v-card-text>
        <v-layout mt-2>
          <v-flex xs8>
            <v-layout column fill-height mx-0>
              <div class="subtitle-1" style="font-weight: 600;text-transform: uppercase;letter-spacing:0.03em">
                {{ displayName }}
              </div>
              <v-layout column>
                <v-flex class="py-0">
                  <div class="text--secondary">
                    <span style="font-weight: 600">Contact:</span>
                    {{ displayContact }}
                  </div>
                </v-flex>
                <v-flex class="py-0">
                  <div class="text--secondary">
                    <span style="font-weight: 600">Requested:</span>
                    {{ enquiry.funding_requested | currency }}
                  </div>
                </v-flex>
                <v-flex class="py-0">
                  <div class="text--secondary" v-if="fundingOffered">
                    <span style="font-weight: 600">Offered:</span>
                    {{ enquiry.funding_offered | currency }}
                  </div>
                </v-flex>
                <v-flex xs4 class="py-0">
                  <div class="text--secondary" v-if="fundingObtained">
                    <span style="font-weight: 600">Obtained:</span>
                    {{ enquiry.funding_obtained | currency }}
                  </div>
                </v-flex>
              </v-layout>
            </v-layout>
          </v-flex>
          <v-flex xs3>
            <v-layout column align-end>
              <v-flex class="text-right">
                <v-btn :color="colour" depressed class="px-3 mx-0" small rounded @click.stop="updateStatus">
                  {{ enquiry.status.name }}
                </v-btn>
                <div class="caption text--secondary">Created: {{ enquiry.created_at | moment('DD/MM/YYYY') }}</div>
                <div class="pt-1">
                  <v-icon v-if="enquiry.revolving" title="Revolving deal">sync</v-icon>
                  <v-icon
                    title="Customer has uploaded documents"
                    size="20"
                    class="pl-1"
                    v-if="enquiry.customer.has_documents"
                    >fas fa-file-alt</v-icon
                  >
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout class="mt-4" column v-if="enquiry.feedback">
          <v-flex class="px-5" xs12 v-for="error in enquiry.feedback.errors" :key="error.id">
            <v-alert type="error" dense prominent border="top" colored-border elevation="3">
              {{ error.detail }}
            </v-alert>
          </v-flex>
          <v-flex class="px-5" xs12 v-if="enquiry.feedback.info">
            <v-alert type="info" dense prominent border="top" elevation="3" colored-border color="#FB8C00">
              <v-simple-table>
                <tbody>
                  <tr v-for="item in enquiry.feedback.info" :key="item.key">
                    <td>{{ item.key }}</td>
                    <td>{{ item.value }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-alert>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider v-if="!last"></v-divider>
    </v-card>
    <enquiry-pending-dialog
      v-if="enquiry.status.name === 'PENDING'"
      :show.sync="showPending"
      :enquiry="enquiry"
    ></enquiry-pending-dialog>
    <enquiry-accepted-dialog
      v-if="enquiry.status.name === 'ENQUIRY ACCEPTED'"
      :show.sync="showAccepted"
      :enquiry="enquiry"
    ></enquiry-accepted-dialog>
    <enquiry-offer-made-dialog
      v-if="enquiry.status.name === 'FUNDER OFFER MADE'"
      :show.sync="showOfferMade"
      :enquiry="enquiry"
    ></enquiry-offer-made-dialog>
    <enquiry-offer-accepted-dialog
      v-if="enquiry.status.name === 'SME OFFER ACCEPTED'"
      :show.sync="showOfferAccepted"
      :enquiry="enquiry"
    ></enquiry-offer-accepted-dialog>
    <enquiry-in-underwriting-dialog
      v-if="enquiry.status.name === 'IN UNDERWRITING'"
      :show.sync="showInUnderwriting"
      :enquiry="enquiry"
    ></enquiry-in-underwriting-dialog>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import EnquiryPendingDialog from '../../Customers/OverviewDrawer/EnquiryActions/EnquiryPendingDialog';
import EnquiryAcceptedDialog from '../../Customers/OverviewDrawer/EnquiryActions/EnquiryAcceptedDialog';
import EnquiryOfferMadeDialog from '../../Customers/OverviewDrawer/EnquiryActions/EnquiryOfferMadeDialog';
import EnquiryOfferAcceptedDialog from '../../Customers/OverviewDrawer/EnquiryActions/EnquiryOfferAcceptedDialog';
import EnquiryInUnderwritingDialog from '../../Customers/OverviewDrawer/EnquiryActions/EnquiryInUnderwritingDialog';

export default {
  components: {
    EnquiryInUnderwritingDialog,
    EnquiryPendingDialog,
    EnquiryAcceptedDialog,
    EnquiryOfferMadeDialog,
    EnquiryOfferAcceptedDialog
  },
  name: 'funder-enquiry-list-tile',
  props: ['enquiry'],
  data: () => ({
    last: false,
    showPending: false,
    showAccepted: false,
    showOfferMade: false,
    showOfferAccepted: false,
    showInUnderwriting: false
  }),
  computed: {
    ...mapGetters(['UserHasRole', 'StatusColours']),
    fundingOffered() {
      return parseFloat(this.enquiry.funding_offered) > 0;
    },
    fundingObtained() {
      return parseFloat(this.enquiry.funding_obtained) > 0;
    },
    fundingReleased() {
      return this.enquiry.status.name === 'FUNDING RELEASED';
    },
    status() {
      return this.enquiry.status.id;
    },
    colour() {
      let status = _.find(this.StatusColours, ['status', this.enquiry.status.name]);
      if (_.isUndefined(status)) {
        status = { colour: 'light-grey' };
      }
      return status.colour;
    },
    displayContact() {
      if (!this.enquiry.customer.contact_name) {
        return '';
      }
      return this.UserHasRole('Platform')
        ? this.enquiry.customer.contact_name.platform
        : this.enquiry.customer.contact_name.provider;
    },
    displayName() {
      if (!this.enquiry.customer.name) {
        return '';
      }
      return this.UserHasRole('Platform') ? this.enquiry.customer.name.platform : this.enquiry.customer.name.provider;
    }
  },
  methods: {
    ...mapActions(['selectEnquiry']),
    updateStatus() {
      switch (this.enquiry.status.name) {
        case 'PENDING':
          this.showPending = true;
          break;
        case 'ENQUIRY ACCEPTED':
          this.showAccepted = true;
          break;
        case 'FUNDER OFFER MADE':
          this.showOfferMade = true;
          break;
        case 'SME OFFER ACCEPTED':
          this.showOfferAccepted = true;
          break;
        case 'IN UNDERWRITING':
          this.showInUnderwriting = true;
          break;
      }
    },
    redirectToCustomer() {
      if (this.enquiry.state === 'Active' || this.UserHasRole('Platform')) {
        this.selectEnquiry(this.enquiry);
        this.$router.push('/customers/' + this.enquiry.customer.id + '/' + this.enquiry.id);
      }
    }
  },
  filters: {
    currency: function(value) {
      const intValue = parseFloat(value);

      return (
        '£' +
        intValue.toLocaleString({
          style: 'currency',
          currency: 'GBP',
          currencyDisplay: 'symbol',
          minimumSignificantDigits: 0,
          maximumSignificantDigits: 0
        })
      );
    }
  },
  mounted() {
    this.last = this.$parent.$children[this.$parent.$children.length - 1] === this;
  }
};
</script>

<style lang="scss" scoped>
.v-avatar {
  img {
    width: 100%;
    height: auto;
    margin-top: auto;
    margin-bottom: auto;
  }
}
.is-link {
  cursor: pointer;
}
</style>
